<script>
    export default {
        methods: {
            validate_email(event) {
                let el = event.target;
                let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!el.value && !el.hasAttribute('required')) {
                    el.setAttribute('validate', 'true');
                } else if (re.test(el.value)) {
                    el.setAttribute('validate', 'true');
                } else {
                    el.setAttribute('validate', 'false');
                }
            }
        }
    }
</script>